import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { SharedQueries } from 'src/app/shared/types/get-query';
import { Brand } from 'src/app/components/company/models/new/brand.model';
import { BrandMapper } from 'src/app/components/company/services/brand-mapper';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Injectable({
	providedIn: 'root'
})
export class BrandFilterService extends IFilterListService<Brand> {
	constructor(private brandMapper: BrandMapper) {
		super();
	}

	search(_search: string): void {
		this.graphQlService
			.getData<any>(SharedQueries.GET_BRANDS, {})
			.pipe(map((res) => res.data.brands.nodes.map((el: any) => this.brandMapper.toBrand(el))))
			.subscribe({
				next: (res: Brand[]) => {
					if (_search) {
						res = res.filter((brand) => brand.name?.toLowerCase().includes(_search.toLowerCase()));
					}

					const datasource: Selectable<Brand>[] = res.map((el) => ({
						...el,
						displayId: el.id!,
						displayName: el.name!,
						disabled: false,
						selected: false
					}));
					this.datasource.next(datasource);
				}
			});
	}

	searchById(_id: string[] | string) {
		return this.graphQlService
			.getData<any>(SharedQueries.GET_BRANDS, {})
			.pipe(map((res) => res.data.brands.nodes.map((el: any) => this.brandMapper.toBrand(el))))
			.pipe(map((res: Brand[]) => res.filter((brand) => (_id instanceof Array ? _id.includes(brand.id + '') : brand.id + '' == _id))));
	}
}